// src/utils/eventDates.js
//
// Single source of truth for the Mzinyi Taita Taveta Awards 2026 key dates.
// Update the three dates below and every page that gates nominations/voting
// (Home, Nominate, Nominee, Vote) picks up the change automatically.
/*
export const NOMINATION_DEADLINE = new Date("2026-10-17T23:59:59").getTime();
export const VOTING_START = new Date("2026-10-19T00:00:00").getTime();
export const VOTING_END = new Date("2026-11-30T23:59:59").getTime();

// Returns 'nominating' | 'voting' | 'closed' based on the current time.
export const getEventPhase = () => {
  const now = Date.now();
  if (now <= NOMINATION_DEADLINE) return 'nominating';
  if (now >= VOTING_START && now <= VOTING_END) return 'voting';
  return 'closed';
};
*/


 // src/utils/eventDates.js
 // Single source of truth for Mzinyi Taita Taveta Awards 2026.

export const NOMINATION_DEADLINE = new Date("2026-10-24T23:59:59").getTime();
export const VOTING_START = new Date("2026-10-26T00:00:00").getTime();
export const VOTING_END = new Date("2026-11-30T23:59:59").getTime();

// Returns 'nominating' | 'voting' | 'closed'
export const getEventPhase = () => {
  const now = Date.now();

  if (now <= NOMINATION_DEADLINE) return "nominating";

  if (now >= VOTING_START && now <= VOTING_END) return "voting";

  return "closed";
};
